// @ts-nocheck
import PropTypes from "prop-types";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import closeIcon from "../../assets/images/floating-menu-icons/cancelX.svg";
import minimizeIcon from "../../assets/images/floating-menu-icons/leftArrow.svg";

const miniModalContainerCls =
  "fixed bottom-[100px] right-[15px] w-[var(--size-70)] bg-[linear-gradient(135deg,var(--color-deep-surface-from)_0%,var(--color-deep-surface-mid)_50%,var(--color-deep-surface-to)_100%)] rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.4)] border border-[rgba(255,255,255,0.1)] z-[1400] animate-mini-slide-in backdrop-blur-[10px] overflow-hidden before:content-[''] before:absolute before:inset-0 before:bg-[linear-gradient(180deg,rgba(255,255,255,0.08)_0%,rgba(255,255,255,0.02)_100%)] before:pointer-events-none before:rounded-2xl max-[480px]:w-[240px] max-[480px]:bottom-20 max-[480px]:right-2.5 max-[360px]:w-[var(--size-50)]";
const miniModalHeaderCls =
  "px-4 py-3 flex items-center justify-between border-b border-[rgba(255,255,255,0.1)] relative z-[var(--z-base)] max-[480px]:px-3 max-[480px]:py-2.5";
const miniModalControlsCls = "flex gap-2";
const minimizeButtonCls =
  "bg-[rgba(255,255,255,0.1)] border border-[rgba(255,255,255,0.1)] rounded-full w-7 h-7 flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-[rgba(255,255,255,0.2)] hover:scale-110";
const closeButtonCls =
  "bg-[rgba(255,255,255,0.1)] border border-[rgba(255,255,255,0.1)] rounded-full w-7 h-7 flex items-center justify-center cursor-pointer transition-all duration-300 hover:bg-[rgba(255,255,255,0.2)] hover:scale-110";
const controlIconCls = "w-3 h-3 brightness-0 invert";
const miniModalContentCls = "p-4 relative z-[var(--z-base)] max-[480px]:p-3";
const gamesListCls = "flex gap-2 mb-3 overflow-x-auto py-1 [&::-webkit-scrollbar]:hidden max-[360px]:gap-1.5";
const miniGameItemCls =
  "shrink-0 w-9 h-9 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 border-2 border-transparent relative hover:scale-110 hover:border-[rgba(102,126,234,0.6)] hover:shadow-[0_4px_12px_rgba(102,126,234,0.3)] max-[480px]:w-8 max-[480px]:h-8 max-[360px]:w-7 max-[360px]:h-7";
const selectedCls = "!scale-110 !border-[rgba(102,126,234,0.6)] !shadow-[0_4px_12px_rgba(102,126,234,0.3)]";
const miniGameIconCls = "w-full h-full relative flex items-center justify-center";
const gameImageCls = "w-full h-full object-cover";
const placeholderIconCls =
  "text-sm bg-[linear-gradient(135deg,var(--color-deep-teal)_0%,var(--color-deep-blue)_100%)] w-full h-full flex items-center justify-center";
const rankBadgeCls =
  "absolute -top-0.5 -right-0.5 bg-[linear-gradient(135deg,var(--color-danger)_0%,var(--color-danger)_100%)] text-white text-[var(--font-eyebrow)] font-bold py-px px-[3px] rounded-md border border-[rgba(255,255,255,0.3)] shadow-[0_1px_4px_rgba(0,0,0,0.3)] z-[2] leading-none max-[480px]:text-[var(--font-eyebrow)] max-[480px]:px-0.5";
const gameInfoCls = "text-center min-h-10 flex flex-col justify-center";
const gameNameCls =
  "text-xs font-semibold text-[var(--color-text)] m-0 mb-1 leading-[1.2] overflow-hidden text-ellipsis [display:-webkit-box] [-webkit-line-clamp:2] [line-clamp:2] [-webkit-box-orient:vertical] max-[480px]:text-[var(--font-caption)]";
const gameProviderCls =
  "text-[var(--font-eyebrow)] text-[rgba(255,255,255,0.6)] m-0 capitalize font-medium max-[480px]:text-[var(--font-eyebrow)]";
const tabSwitcherCls = "flex gap-1";
const tabButtonCls =
  "bg-[rgba(255,255,255,0.1)] border border-[rgba(255,255,255,0.2)] rounded-lg w-8 h-8 flex items-center justify-center cursor-pointer transition-all duration-300 text-sm hover:bg-[rgba(255,255,255,0.2)] hover:scale-105 max-[360px]:w-7 max-[360px]:h-7 max-[360px]:text-xs";
const activeTabCls =
  "!bg-[linear-gradient(135deg,var(--color-accent-purple-from)_0%,var(--color-accent-purple-to)_100%)] !scale-110";
const sportsContentCls = "p-4 text-center text-[rgba(255,255,255,0.8)]";
const sportsMessageCls = "[&_p]:m-0 [&_p]:mb-3 [&_p]:text-xs [&_p]:leading-[1.4]";
const expandButtonCls =
  "bg-[linear-gradient(135deg,var(--color-accent-purple-from)_0%,var(--color-accent-purple-to)_100%)] border border-[rgba(255,255,255,0.3)] rounded-lg text-white py-2 px-3 text-[var(--font-caption)] font-semibold cursor-pointer transition-all duration-300 hover:bg-[linear-gradient(135deg,var(--color-accent-purple-from-hover)_0%,var(--color-accent-purple-to-hover)_100%)] hover:-translate-y-px hover:shadow-[0_4px_12px_rgba(102,126,234,0.3)]";

const MiniGameModal = ({isOpen, onClose, onMinimize, games, onGameSelect}) => {
  const {t} = useTranslation();
  const modalRef = useRef(null);
  const [selectedGame, setSelectedGame] = useState(null);
  const [activeTab, setActiveTab] = useState("casino");

  // Handle click outside to close
  useEffect(() => {
    const handleClickOutside = event => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleGameClick = game => {
    setSelectedGame(game);
    // Use onGameSelect instead of navigate for parallel gaming
    onGameSelect(game);
  };

  const handleGameHover = game => {
    setSelectedGame(game);
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={miniModalContainerCls}
      ref={modalRef}
    >
      <div className={miniModalHeaderCls}>
        <div className={tabSwitcherCls}>
          <button
            type="button"
            className={`${tabButtonCls} ${activeTab === "casino" ? activeTabCls : ""}`}
            onClick={() => setActiveTab("casino")}
          >
            �
          </button>
          <button
            type="button"
            className={`${tabButtonCls} ${activeTab === "sports" ? activeTabCls : ""}`}
            onClick={() => setActiveTab("sports")}
          >
            ⚽
          </button>
        </div>
        <div className={miniModalControlsCls}>
          <button
            type="button"
            className={minimizeButtonCls}
            onClick={onMinimize}
            title={t("expandQuickGames", "Expand")}
          >
            <img
              src={minimizeIcon}
              alt="Expand"
              className={controlIconCls}
            />
          </button>
          <button
            type="button"
            className={closeButtonCls}
            onClick={onClose}
            title={t("hideQuickGames", "Hide")}
          >
            <img
              src={closeIcon}
              alt="Close"
              className={controlIconCls}
            />
          </button>
        </div>
      </div>

      <div className={miniModalContentCls}>
        {activeTab === "casino" && (
          <>
            <div className={gamesListCls}>
              {games.slice(0, 6).map((game, index) => (
                <div
                  key={game.id || index}
                  className={`${miniGameItemCls} ${selectedGame?.id === game.id ? selectedCls : ""}`}
                  onClick={() => handleGameClick(game)}
                  onMouseEnter={() => handleGameHover(game)}
                >
                  <div className={miniGameIconCls}>
                    {game.icon ? (
                      <img
                        src={game.icon}
                        alt={game.name || game.game_name}
                        className={gameImageCls}
                      />
                    ) : (
                      <span className={placeholderIconCls}>🎮</span>
                    )}
                    <div className={rankBadgeCls}>#{index + 1}</div>
                  </div>
                </div>
              ))}
            </div>

            {selectedGame && (
              <div className={gameInfoCls}>
                <h4 className={gameNameCls}>{selectedGame.name || selectedGame.game_name}</h4>
                <p className={gameProviderCls}>{selectedGame.provider}</p>
              </div>
            )}
          </>
        )}

        {activeTab === "sports" && (
          <div className={sportsContentCls}>
            <div className={sportsMessageCls}>
              <p>{t("expandForSports", "Expand for full sports experience")}</p>
              <button
                type="button"
                className={expandButtonCls}
                onClick={onMinimize}
              >
                {t("expand", "Expand")} ↗️
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

MiniGameModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onMinimize: PropTypes.func.isRequired,
  games: PropTypes.arrayOf(PropTypes.object).isRequired,
  onGameSelect: PropTypes.func.isRequired,
};

export default MiniGameModal;
